module.exports = __webpack_public_path__ + "img/symbol_6.3d1de9a9.png";